// accAggregators.js
// Consolidated from accAggregators_pol.js, accAggregators_policy.js, accAggregators_climate.js

// ─── ACC Politics ─────────────────────────────────────────────────────────────

export function getACCPoliticscolors() {
  const DISTINCT = [
    "#4e79a7", "#f28e2b", "#e15759", "#76b7b2", "#59a14f",
    "#edc948", "#b07aa1", "#ff9da7", "#9c755f", "#bab0ab"
  ];
  return DISTINCT;
}

export function getACCPoliticsConfig() {
  const groupsById = {

   pol_bbb_impact: {
    type: "likert",
    label: "Impact of Trump's 'Big Beautiful Bill'",
    fulltext: "Thinking about the long-term impact of President Trump's 'Big Beautiful Bill', what best reflects your view?",
    keys: [
      "model_BBB_1_pred_n",
      "model_BBB_2_pred_n",
      "model_BBB_3_pred_n",
      "model_BBB_4_pred_n",
      "model_BBB_5_pred_n",
      "model_BBB_6_pred_n",
      "model_BBB_7_pred_n",
    ],
    labels: {
      "model_BBB_1_pred_n": "A major step forward for the country",
      "model_BBB_2_pred_n": "A positive change, though not perfect",
      "model_BBB_3_pred_n": "I don't think it will have much impact",
      "model_BBB_4_pred_n": "Too soon to tell",
      "model_BBB_5_pred_n": "I don't know enough to say",
      "model_BBB_6_pred_n": "A step in the wrong direction",
      "model_BBB_7_pred_n": "A serious setback",
    },
    colors: {
      "model_BBB_1_pred_n": "#1b5e20",
      "model_BBB_2_pred_n": "#66bb6a",
      "model_BBB_3_pred_n": "#9e9e9e",
      "model_BBB_4_pred_n": "#bdbdbd",
      "model_BBB_5_pred_n": "#e0e0e0",
      "model_BBB_6_pred_n": "#ef5350",
      "model_BBB_7_pred_n": "#b71c1c",
    },
    polarity: {
      pos: ["model_BBB_1_pred_n", "model_BBB_2_pred_n"],
      neu: ["model_BBB_3_pred_n", "model_BBB_4_pred_n", "model_BBB_5_pred_n"],
      neg: ["model_BBB_6_pred_n", "model_BBB_7_pred_n"],
    },
      schema:"acc",
      waves: [2],
  },


  pol_maba_familiarity: {
    type: "likert",
    label: "Familiarity with 'Make America Beautiful Again'",
    fulltext: "On July 3rd, 2025, President Trump signed the 'Make America Beautiful Again' executive order. Before today, how familiar were you with this?",
    keys: [
      "model_MABA_1_pred_n",
      "model_MABA_2_pred_n",
      "model_MABA_3_pred_n",
      "model_MABA_4_pred_n",
      "model_MABA_5_pred_n",
    ],
    labels: {
      "model_MABA_1_pred_n": "I've never heard of it",
      "model_MABA_2_pred_n": "I've heard the name but know nothing about it",
      "model_MABA_3_pred_n": "I'm somewhat familiar with it",
      "model_MABA_4_pred_n": "I know quite a bit about it",
      "model_MABA_5_pred_n": "I'm very familiar with the details",
    },
    colors: {
      "model_MABA_1_pred_n": "#757575",
      "model_MABA_2_pred_n": "#bdbdbd",
      "model_MABA_3_pred_n": "#7986cb",
      "model_MABA_4_pred_n": "#3949ab",
      "model_MABA_5_pred_n": "#1a237e",
    },
    polarity: {
      neg: ["model_MABA_1_pred_n", "model_MABA_2_pred_n"],
      neu: "model_MABA_3_pred_n",
      pos: ["model_MABA_4_pred_n", "model_MABA_5_pred_n"],
    },
      schema:"acc",
      waves: [2],
  },



  pol_rep_env_support: {
    type: "likert",
    label: "Support for Republican candidate with environmental agenda",
    fulltext: "Would you be more likely to support or oppose a Republican candidate who includes environmental issues in their policy agenda?",
    keys: [
      "model_rep_env_support_pred_n",
      "model_rep_env_niether_pred_n",
      "model_rep_env_oppose_pred_n",
    ],
    labels: {
      "model_rep_env_support_pred_n": "Support",
      "model_rep_env_niether_pred_n": "Neither",
      "model_rep_env_oppose_pred_n": "Oppose",
    },
    colors: {
      "model_rep_env_support_pred_n": "#2e7d32",
      "model_rep_env_niether_pred_n": "#9e9e9e",
      "model_rep_env_oppose_pred_n": "#c62828",
    },
    polarity: {
      pos: "model_rep_env_support_pred_n",
      neu: "model_rep_env_niether_pred_n",
      neg: "model_rep_env_oppose_pred_n",
    },
      schema:"acc",
      waves: [2,3],
  },

  // pol_rep_prioritize: {
  //   type: "likert",
  //   label: "Should GOP prioritize environment",
  //   fulltext: "To what extent do you think the Republican party should prioritize environmental conservation and sustainability in its policy agenda?",
  //   keys: [
  //     "model_rep_prioritize_yes_pred_n",
  //     "model_rep_prioritize_no_pred_n",
  //     "model_rep_prioritize_unsure_pred_n",
  //     "model_rep_prioritize_notRep_pred_n",
  //   ],
  //   labels: {
  //     "model_rep_prioritize_yes_pred_n": "Prioritize",
  //     "model_rep_prioritize_no_pred_n": "Do not prioritize",
  //     "model_rep_prioritize_unsure_pred_n": "Not Sure",
  //     "model_rep_prioritize_notRep_pred_n": "Not Republican",
  //   },
  //   colors: {
  //     "model_rep_prioritize_yes_pred_n": "#2e7d32",
  //     "model_rep_prioritize_no_pred_n": "#d84315",
  //     "model_rep_prioritize_unsure_pred_n": "#bdbdbd",
  //     "model_rep_prioritize_notRep_pred_n": "#616161",
  //   },
  //   polarity: {
  //     pos: "model_rep_prioritize_yes_pred_n",
  //     neg: "model_rep_prioritize_no_pred_n",
  //     neu: ["model_rep_prioritize_unsure_pred_n", "model_rep_prioritize_notRep_pred_n"],
  //   },
  //     schema:"acc",
  // },
    // --- Top Issues Facing the Country ---
    pol_top_issues: {
      type: "categorical",
      label: "Top Issues Facing the Country",
      fulltext: "What do you think are the top three most important issues facing the country right now?",
      keys: [
        "model_issues_jobsEcon_pred_n",
        "model_issues_immigration_pred_n",
        "model_issues_inflation_pred_n",
        "model_issues_health_pred_n",
        "model_issues_crime_pred_n",
        "model_issues_natsec_pred_n",
        "model_issues_natdebt_pred_n",
        "model_issues_education_pred_n",
        "model_issues_housing_pred_n",
        "model_issues_climate_pred_n",
        "model_issues_taxes_pred_n",
        "model_issues_abortion_pred_n",
        "model_issues_covid_pred_n",
      ],
      labels: {
        "model_issues_jobsEcon_pred_n":    "Jobs & The Economy",
        "model_issues_immigration_pred_n": "Immigration",
        "model_issues_inflation_pred_n":   "Inflation",
        "model_issues_health_pred_n":      "Health",
        "model_issues_crime_pred_n":       "Crime",
        "model_issues_natsec_pred_n":      "National Security",
        "model_issues_natdebt_pred_n":     "National Debt",
        "model_issues_education_pred_n":   "Education",
        "model_issues_housing_pred_n":     "Housing",
        "model_issues_climate_pred_n":     "Climate",
        "model_issues_taxes_pred_n":       "Taxes",
        "model_issues_abortion_pred_n":    "Abortion",
        "model_issues_covid_pred_n":       "COVID-19",
      },
      schema: "acc",
      waves: [2,3],
    },


  };

  return { groupsById };
}

// ─── ACC Policy ───────────────────────────────────────────────────────────────

export function getACCPolicycolors() {
  const DISTINCT = [
    "#4e79a7", "#f28e2b", "#e15759", "#76b7b2", "#59a14f",
    "#edc948", "#b07aa1", "#ff9da7", "#9c755f", "#bab0ab"
  ];
  return DISTINCT;
}

export function getACCPolicyConfig() {
  const groupsById = {

      pol_public_lands_mgmt: {
        type: "categorical",
        label: "Who should manage public lands",
        fulltext: "Who do you think should have the most say in how public lands are managed?",
        keys: [
          "model_public_lands_1_pred_n",
          "model_public_lands_2_pred_n",
          "model_public_lands_3_pred_n",
          "model_public_lands_4_pred_n",
          "model_public_lands_5_pred_n",
          "model_public_lands_6_pred_n",
          "model_public_lands_7_pred_n",
        ],
        labels: {
          "model_public_lands_1_pred_n": "The general public (through voting or public input)",
          "model_public_lands_2_pred_n": "Tribal nations",
          "model_public_lands_3_pred_n": "Local communities",
          "model_public_lands_4_pred_n": "Not sure",
          "model_public_lands_5_pred_n": "State governments",
          "model_public_lands_6_pred_n": "Private landowners and businesses",
          "model_public_lands_7_pred_n": "The federal government",
        },
      schema:"acc",
      waves: [2],
      },

        // --- Future Energy Needs ---
        pol_future_energy: {
          type: "categorical",
          label: "US Energy needs in next 20 years",
          fulltext: "Broadly speaking, over the next 5, 10, and 20 years, how do you think the United States' overall energy needs will change?",
          keys: [
            "model_future_energy_1_pred_n",
            "model_future_energy_2_pred_n",
            "model_future_energy_3_pred_n",
            "model_future_energy_4_pred_n",
            "model_future_energy_5_pred_n",
          ],
          labels: {
            "model_future_energy_1_pred_n": "Continue to grow",
            "model_future_energy_2_pred_n": "Fluctuate (grow and decline periodically)",
            "model_future_energy_3_pred_n": "Stay about the same",
            "model_future_energy_4_pred_n": "Not sure",
            "model_future_energy_5_pred_n": "Continue to decline",
          },
      schema:"acc",
      waves: [2,3],
        },
        // --- General Permitting ---
    pol_permitting_general: {
      type: "likert",
      label: "Speed up permitting vs Environmental protections",
      fulltext: "Recent efforts to speed up permitting in the U.S. aim to make it easier to build infrastructure... Others worry it weakens important environmental and community protections. How do you personally see this trade-off?",
      keys: [
        "model_permitting_1_pred_n",
        "model_permitting_2_pred_n",
        "model_permitting_3_pred_n",
        "model_permitting_4_pred_n",
        "model_permitting_5_pred_n",
        "model_permitting_6_pred_n",
      ],
      labels: {
        "model_permitting_1_pred_n": "Strongly favor faster permitting, even if some protections are reduced",
        "model_permitting_2_pred_n": "Lean toward faster permitting, but protections still matter",
        "model_permitting_3_pred_n": "Balanced approach is essential",
        "model_permitting_4_pred_n": "Unsure / don't know",
        "model_permitting_5_pred_n": "Lean toward stronger protections, even if it slows some projects",
        "model_permitting_6_pred_n": "Strongly favor maintaining protections, even if it delays building",
      },

      colors: {
        "model_permitting_1_pred_n": "#b71c1c",
        "model_permitting_2_pred_n": "#ef5350",
        "model_permitting_3_pred_n": "#bdbdbd",
        "model_permitting_4_pred_n": "#9e9e9e",
        "model_permitting_5_pred_n": "#a2dda5",
        "model_permitting_6_pred_n": "#2e7d32",
      },

      polarity: {
        neg: ["model_permitting_1_pred_n", "model_permitting_2_pred_n"],
        neu: ["model_permitting_3_pred_n", "model_permitting_4_pred_n"],
        pos: ["model_permitting_5_pred_n", "model_permitting_6_pred_n"],
      },
      schema:"acc",
      waves: [2],
    },

    pol_federal_conservation: {
      type: "likert",
      label: "Federal Lands: Prioritizing conservation",
      fulltext: "There is longstanding debate over how federally owned public lands should be used. Where do you stand on: Prioritizing conservation and recreation over commercial use?",
      keys: [
        "model_federal_conservation_support_pred_n",
        "model_federal_conservation_nuetral_pred_n",
        "model_federal_conservation_oppose_pred_n",
      ],
      labels: {
        "model_federal_conservation_support_pred_n": "Support",
        "model_federal_conservation_nuetral_pred_n": "Neutral",
        "model_federal_conservation_oppose_pred_n": "Oppose",
      },
      polarity: {
        pos: "model_federal_conservation_support_pred_n",
        neu: "model_federal_conservation_nuetral_pred_n",
        neg: "model_federal_conservation_oppose_pred_n",
      },
      schema:"acc",
      waves: [2],
    },

    // --- Federal Lands: Oil ---
    pol_federal_oil: {
      type: "likert",
      label: "Federal Lands: Oil and gas drilling",
      fulltext: "There is longstanding debate over how federally owned public lands should be used. Where do you stand on: Allowing more oil and gas drilling on federal lands?",
      keys: [
        "model_federal_oil_support_pred_n",
        "model_federal_oil_nuetral_pred_n",
        "model_federal_oil_oppose_pred_n",
      ],
      labels: {
        "model_federal_oil_support_pred_n": "Support",
        "model_federal_oil_nuetral_pred_n": "Neutral",
        "model_federal_oil_oppose_pred_n": "Oppose",
      },
      polarity: {
        pos: "model_federal_oil_support_pred_n",
        neu: "model_federal_oil_nuetral_pred_n",
        neg: "model_federal_oil_oppose_pred_n",
      },
      schema:"acc",
      waves: [2],
    },

    // --- Federal Lands: Protected Areas ---
    pol_federal_protected: {
      type: "likert",
      label: "Federal Lands: Expanding protected areas",
      fulltext: "There is longstanding debate over how federally owned public lands should be used. Where do you stand on: Expanding protected areas like national parks and monuments?",
      keys: [
        "model_federal_protected_support_pred_n",
        "model_federal_protected_nuetral_pred_n",
        "model_federal_protected_oppose_pred_n",
      ],
      labels: {
        "model_federal_protected_support_pred_n": "Support",
        "model_federal_protected_nuetral_pred_n": "Neutral",
        "model_federal_protected_oppose_pred_n": "Oppose",
      },
      polarity: {
        pos: "model_federal_protected_support_pred_n",
        neu: "model_federal_protected_nuetral_pred_n",
        neg: "model_federal_protected_oppose_pred_n",
      },
      schema:"acc",
      waves: [2],
    },

    pol_federal_ranching: {
      type: "likert",
      label: "Federal Lands: Private ranching/mining",
      fulltext: "There is longstanding debate over how federally owned public lands should be used. Where do you stand on: Allowing private ranching, mining, or logging under federal leases?",
      keys: [
        "model_federal_ranching_support_pred_n",
        "model_federal_ranching_nuetral_pred_n",
        "model_federal_ranching_oppose_pred_n",
      ],
      labels: {
        "model_federal_ranching_support_pred_n": "Support",
        "model_federal_ranching_nuetral_pred_n": "Neutral",
        "model_federal_ranching_oppose_pred_n": "Oppose",
      },
      polarity: {
        pos: "model_federal_ranching_support_pred_n",
        neu: "model_federal_ranching_nuetral_pred_n",
        neg: "model_federal_ranching_oppose_pred_n",
      },
      schema:"acc",
      waves: [2],
    },

    pol_federal_renew: {
      type: "likert",
      label: "Federal Lands: Renewable energy projects",
      fulltext: "There is longstanding debate over how federally owned public lands should be used. Where do you stand on: Making it easier to build renewable energy projects on public lands?",
      keys: [
        "model_federal_renew_support_pred_n",
        "model_federal_renew_nuetral_pred_n",
        "model_federal_renew_oppose_pred_n",
      ],
      labels: {
        "model_federal_renew_support_pred_n": "Support",
        "model_federal_renew_nuetral_pred_n": "Neutral",
        "model_federal_renew_oppose_pred_n": "Oppose",
      },
      polarity: {
        pos: "model_federal_renew_support_pred_n",
        neu: "model_federal_renew_nuetral_pred_n",
        neg: "model_federal_renew_oppose_pred_n",
      },
      schema:"acc",
      waves: [2],
    },

    pol_federal_transfer: {
      type: "likert",
      label: "Federal Lands: Transferring to state/local",
      fulltext: "There is longstanding debate over how federally owned public lands should be used. Where do you stand on: Transferring some federal lands to state or local control?",
      keys: [
        "model_federal_transferring_support_pred_n",
        "model_federal_transferring_nuetral_pred_n",
        "model_federal_transferring_oppose_pred_n",
      ],
      labels: {
        "model_federal_transferring_support_pred_n": "Support",
        "model_federal_transferring_nuetral_pred_n": "Neutral",
        "model_federal_transferring_oppose_pred_n": "Oppose",
      },
      polarity: {
        pos: "model_federal_transferring_support_pred_n",
        neu: "model_federal_transferring_nuetral_pred_n",
        neg: "model_federal_transferring_oppose_pred_n",
      },
      schema:"acc",
      waves: [2],
    },


    pol_highway_permitting: {
      type: "likert",
      label: "Permitting: Highway expansion vs Protection",
      fulltext: "A highway expansion that crosses streams and marshland: Please indicate how you think the U.S. should balance permitting speed with environmental protection under the Clean Water Act.",
      keys: [
        "model_highway_permitting_1_pred_n",
        "model_highway_permitting_2_pred_n",
        "model_highway_permitting_3_pred_n",
        "model_highway_permitting_4_pred_n",
        "model_highway_permitting_5_pred_n",
        "model_highway_permitting_6_pred_n",
      ],
      labels: {
        "model_highway_permitting_1_pred_n": "Prioritize faster permitting",
        "model_highway_permitting_2_pred_n": "Lean toward permitting",
        "model_highway_permitting_3_pred_n": "Balance both",
        "model_highway_permitting_4_pred_n": "Not sure",
        "model_highway_permitting_5_pred_n": "Lean toward stronger protections",
        "model_highway_permitting_6_pred_n": "Prioritize Clean Water Act protections",
      },
      colors: {
        "model_highway_permitting_1_pred_n": "#b71c1c",
        "model_highway_permitting_2_pred_n": "#ef5350",
        "model_highway_permitting_3_pred_n": "#bdbdbd",
        "model_highway_permitting_4_pred_n": "#9e9e9e",
        "model_highway_permitting_5_pred_n": "#a2dda5",
        "model_highway_permitting_6_pred_n": "#2e7d32",
      },
      schema:"acc",

      polarity: {
        neg: ["model_highway_permitting_1_pred_n", "model_highway_permitting_2_pred_n"],
        neu: ["model_highway_permitting_3_pred_n", "model_highway_permitting_4_pred_n"],
        pos: ["model_highway_permitting_5_pred_n", "model_highway_permitting_6_pred_n"],
      },
      waves: [2],
    },

    pol_housing_permitting: {
      type: "likert",
      label: "Permitting: Housing development vs Protection",
      fulltext: "A housing development in a flood-prone area: Please indicate how you think the U.S. should balance permitting speed with environmental protection under the Clean Water Act.",
      keys: [
        "model_housing_permitting_1_pred_n",
        "model_housing_permitting_2_pred_n",
        "model_housing_permitting_3_pred_n",
        "model_housing_permitting_4_pred_n",
        "model_housing_permitting_5_pred_n",
        "model_housing_permitting_6_pred_n",
      ],
      labels: {
        "model_housing_permitting_1_pred_n": "Prioritize faster permitting",
        "model_housing_permitting_2_pred_n": "Lean toward permitting",
        "model_housing_permitting_3_pred_n": "Balance both",
        "model_housing_permitting_4_pred_n": "Not sure",
        "model_housing_permitting_5_pred_n": "Lean toward stronger protections",
        "model_housing_permitting_6_pred_n": "Prioritize Clean Water Act protections",
      },

      colors: {
        "model_housing_permitting_1_pred_n": "#b71c1c",
        "model_housing_permitting_2_pred_n": "#ef5350",
        "model_housing_permitting_3_pred_n": "#bdbdbd",
        "model_housing_permitting_4_pred_n": "#9e9e9e",
        "model_housing_permitting_5_pred_n": "#a2dda5",
        "model_housing_permitting_6_pred_n": "#2e7d32",
      },
      polarity: {
        neg: ["model_housing_permitting_1_pred_n", "model_housing_permitting_2_pred_n"],
        neu: ["model_housing_permitting_3_pred_n", "model_housing_permitting_4_pred_n"],
        pos: ["model_housing_permitting_5_pred_n", "model_housing_permitting_6_pred_n"],
      },
      schema:"acc",
      waves: [2],
    },



    pol_rural_town_permitting: {
      type: "likert",
      label: "Permitting: Rural water treatment vs Protection",
      fulltext: "A rural town needing faster approval for a water treatment plant: Please indicate how you think the U.S. should balance permitting speed with environmental protection under the Clean Water Act.",
      keys: [
        "model_rural_town_permitting_1_pred_n",
        "model_rural_town_permitting_2_pred_n",
        "model_rural_town_permitting_3_pred_n",
        "model_rural_town_permitting_4_pred_n",
        "model_rural_town_permitting_5_pred_n",
        "model_rural_town_permitting_6_pred_n",
      ],
      labels: {
        "model_rural_town_permitting_1_pred_n": "Prioritize faster permitting",
        "model_rural_town_permitting_2_pred_n": "Lean toward permitting",
        "model_rural_town_permitting_3_pred_n": "Balance both",
        "model_rural_town_permitting_4_pred_n": "Not sure",
        "model_rural_town_permitting_5_pred_n": "Lean toward stronger protections",
        "model_rural_town_permitting_6_pred_n": "Prioritize Clean Water Act protections",
      },

      colors: {
        "model_rural_town_permitting_1_pred_n": "#b71c1c",
        "model_rural_town_permitting_2_pred_n": "#ef5350",
        "model_rural_town_permitting_3_pred_n": "#bdbdbd",
        "model_rural_town_permitting_4_pred_n": "#9e9e9e",
        "model_rural_town_permitting_5_pred_n": "#a2dda5",
        "model_rural_town_permitting_6_pred_n": "#2e7d32",
      },


      polarity: {
        neg: ["model_rural_town_permitting_1_pred_n", "model_rural_town_permitting_2_pred_n"],
        neu: ["model_rural_town_permitting_3_pred_n", "model_rural_town_permitting_4_pred_n"],
        pos: ["model_rural_town_permitting_5_pred_n", "model_rural_town_permitting_6_pred_n"],
      },
      schema:"acc",
      waves: [2],
    },

    pol_solar_permitting: {
      type: "likert",
      label: "Permitting: Solar company vs Protection",
      fulltext: "A solar energy company building near wetlands: Please indicate how you think the U.S. should balance permitting speed with environmental protection under the Clean Water Act.",
      keys: [
        "model_solar_permitting_1_pred_n",
        "model_solar_permitting_2_pred_n",
        "model_solar_permitting_3_pred_n",
        "model_solar_permitting_4_pred_n",
        "model_solar_permitting_5_pred_n",
        "model_solar_permitting_6_pred_n",
      ],
      labels: {
        "model_solar_permitting_1_pred_n": "Prioritize faster permitting",
        "model_solar_permitting_2_pred_n": "Lean toward permitting",
        "model_solar_permitting_3_pred_n": "Balance both",
        "model_solar_permitting_4_pred_n": "Not sure",
        "model_solar_permitting_5_pred_n": "Lean toward stronger protections",
        "model_solar_permitting_6_pred_n": "Prioritize Clean Water Act protections",
      },

      colors: {
        "model_solar_permitting_1_pred_n": "#b71c1c",
        "model_solar_permitting_2_pred_n": "#ef5350",
        "model_solar_permitting_3_pred_n": "#bdbdbd",
        "model_solar_permitting_4_pred_n": "#9e9e9e",
        "model_solar_permitting_5_pred_n": "#a2dda5",
        "model_solar_permitting_6_pred_n": "#2e7d32",
      },
      polarity: {
        neg: ["model_solar_permitting_1_pred_n", "model_solar_permitting_2_pred_n"],
        neu: ["model_solar_permitting_3_pred_n", "model_solar_permitting_4_pred_n"],
        pos: ["model_solar_permitting_5_pred_n", "model_solar_permitting_6_pred_n"],
      },
      schema:"acc",
      waves: [2],
    },



    // pol_public_lands_mgmt: {
    //   type: "categorical",
    //   label: "Who should manage public lands",
    //   fulltext: "Who do you think should have the most say in how public lands are managed?",
    //   keys: [
    //     "model_public_lands_1_pred_n",
    //     "model_public_lands_2_pred_n",
    //     "model_public_lands_3_pred_n",
    //     "model_public_lands_4_pred_n",
    //     "model_public_lands_5_pred_n",
    //     "model_public_lands_6_pred_n",
    //     "model_public_lands_7_pred_n",
    //   ],
    //   labels: {
    //     "model_public_lands_1_pred_n": "The general public (through voting or public input)",
    //     "model_public_lands_2_pred_n": "Tribal nations",
    //     "model_public_lands_3_pred_n": "Local communities",
    //     "model_public_lands_4_pred_n": "Not sure",
    //     "model_public_lands_5_pred_n": "State governments",
    //     "model_public_lands_6_pred_n": "Private landowners and businesses",
    //     "model_public_lands_7_pred_n": "The federal government",
    //   },
    //   schema:"acc",
    // },

    pol_speed_clean_energy: {
      type: "likert",
      label: "Clean energy projects: Speed vs Environment",
      fulltext: "Clean energy projects (e.g. nuclear, solar, wind): When it comes to speeding up construction... indicate whether you think we should prioritize building quickly or protecting the environment - even if it means delays.",
      keys: [
        "model_speed_clean_energy_1_pred_n",
        "model_speed_clean_energy_2_pred_n",
        "model_speed_clean_energy_3_pred_n",
        "model_speed_clean_energy_4_pred_n",
        "model_speed_clean_energy_5_pred_n",
        "model_speed_clean_energy_6_pred_n",
      ],
      labels: {
        "model_speed_clean_energy_1_pred_n": "Strongly prioritize faster building",
        "model_speed_clean_energy_2_pred_n": "Somewhat prioritize faster building",
        "model_speed_clean_energy_3_pred_n": "Balance both equally",
        "model_speed_clean_energy_4_pred_n": "Not sure",
        "model_speed_clean_energy_5_pred_n": "Somewhat prioritize environmental protections",
        "model_speed_clean_energy_6_pred_n": "Strongly prioritize environmental protections",
      },

      colors: {
        "model_speed_clean_energy_1_pred_n": "#b71c1c",
        "model_speed_clean_energy_2_pred_n": "#ef5350",
        "model_speed_clean_energy_3_pred_n": "#bdbdbd",
        "model_speed_clean_energy_4_pred_n": "#9e9e9e",
        "model_speed_clean_energy_5_pred_n": "#a2dda5",
        "model_speed_clean_energy_6_pred_n": "#2e7d32",
      },

      polarity: {
        neg: ["model_speed_clean_energy_1_pred_n", "model_speed_clean_energy_2_pred_n"],
        neu: ["model_speed_clean_energy_3_pred_n", "model_speed_clean_energy_4_pred_n"],
        pos: ["model_speed_clean_energy_5_pred_n","model_speed_clean_energy_6_pred_n"],
      },
      schema:"acc",
      waves: [2],
    },

    pol_speed_commercial: {
      type: "likert",
      label: "Commercial/Industrial projects: Speed vs Environment",
      fulltext: "Large commercial or industrial projects (e.g. warehouses, data centers): When it comes to speeding up construction... indicate whether you think we should prioritize building quickly or protecting the environment - even if it means delays.",
      keys: [
        "model_speed_commercial_1_pred_n",
        "model_speed_commercial_2_pred_n",
        "model_speed_commercial_3_pred_n",
        "model_speed_commercial_4_pred_n",
        "model_speed_commercial_5_pred_n",
        "model_speed_commercial_6_pred_n",
      ],
      labels: {
        "model_speed_commercial_1_pred_n": "Strongly prioritize faster building",
        "model_speed_commercial_2_pred_n": "Somewhat prioritize faster building",
        "model_speed_commercial_3_pred_n": "Balance both equally",
        "model_speed_commercial_4_pred_n": "Not sure",
        "model_speed_commercial_5_pred_n": "Somewhat prioritize environmental protections",
        "model_speed_commercial_6_pred_n": "Strongly prioritize environmental protections",
      },

      colors: {
        "model_speed_commercial_1_pred_n": "#b71c1c",
        "model_speed_commercial_2_pred_n": "#ef5350",
        "model_speed_commercial_3_pred_n": "#bdbdbd",
        "model_speed_commercial_4_pred_n": "#9e9e9e",
        "model_speed_commercial_5_pred_n": "#a2dda5",
        "model_speed_commercial_6_pred_n": "#2e7d32",
      },

      polarity: {
        neg: ["model_speed_commercial_1_pred_n", "model_speed_commercial_2_pred_n"],
        neu: ["model_speed_commercial_3_pred_n", "model_speed_commercial_4_pred_n"],
        pos: ["model_speed_commercial_5_pred_n", "model_speed_commercial_6_pred_n"],
      },
      schema:"acc",
      waves: [2],
    },

    pol_speed_factories: {
      type: "likert",
      label: "Factories (US Manufacturing): Speed vs Environment",
      fulltext: "Factories to bring back U.S. manufacturing: When it comes to speeding up construction... indicate whether you think we should prioritize building quickly or protecting the environment - even if it means delays.",
      keys: [
        "model_speed_factories_1_pred_n",
        "model_speed_factories_2_pred_n",
        "model_speed_factories_3_pred_n",
        "model_speed_factories_4_pred_n",
        "model_speed_factories_5_pred_n",
        "model_speed_factories_6_pred_n",
      ],
      labels: {
        "model_speed_factories_1_pred_n": "Strongly prioritize faster building",
        "model_speed_factories_2_pred_n": "Somewhat prioritize faster building",
        "model_speed_factories_3_pred_n": "Balance both equally",
        "model_speed_factories_4_pred_n": "Not sure",
        "model_speed_factories_5_pred_n": "Somewhat prioritize environmental protections",
        "model_speed_factories_6_pred_n": "Strongly prioritize environmental protections",
      },

      colors: {
        "model_speed_factories_1_pred_n": "#b71c1c",
        "model_speed_factories_2_pred_n": "#ef5350",
        "model_speed_factories_3_pred_n": "#bdbdbd",
        "model_speed_factories_4_pred_n": "#9e9e9e",
        "model_speed_factories_5_pred_n": "#a2dda5",
        "model_speed_factories_6_pred_n": "#2e7d32",
      },
      polarity: {
        neg: ["model_speed_factories_1_pred_n", "model_speed_factories_2_pred_n"],
        neu: ["model_speed_factories_3_pred_n", "model_speed_factories_4_pred_n"],
        pos: ["model_speed_factories_5_pred_n", "model_speed_factories_6_pred_n"],
      },
      schema:"acc",
      waves: [2],
    },

    pol_speed_housing: {
      type: "likert",
      label: "New Housing: Speed vs Environment",
      fulltext: "New housing in cities and suburbs: When it comes to speeding up construction... indicate whether you think we should prioritize building quickly or protecting the environment - even if it means delays.",
      keys: [
        "model_speed_housing_1_pred_n",
        "model_speed_housing_2_pred_n",
        "model_speed_housing_3_pred_n",
        "model_speed_housing_4_pred_n",
        "model_speed_housing_5_pred_n",
        "model_speed_housing_6_pred_n",
      ],
      labels: {
        "model_speed_housing_1_pred_n": "Strongly prioritize faster building",
        "model_speed_housing_2_pred_n": "Somewhat prioritize faster building",
        "model_speed_housing_3_pred_n": "Balance both equally",
        "model_speed_housing_4_pred_n": "Not sure",
        "model_speed_housing_5_pred_n": "Somewhat prioritize environmental protections",
        "model_speed_housing_6_pred_n": "Strongly prioritize environmental protections",
      },


      colors: {
        "model_speed_housing_1_pred_n": "#b71c1c",
        "model_speed_housing_2_pred_n": "#ef5350",
        "model_speed_housing_3_pred_n": "#bdbdbd",
        "model_speed_housing_4_pred_n": "#9e9e9e",
        "model_speed_housing_5_pred_n": "#a2dda5",
        "model_speed_housing_6_pred_n": "#2e7d32",
      },
      polarity: {
        neg: ["model_speed_housing_1_pred_n", "model_speed_housing_2_pred_n"],
        neu: ["model_speed_housing_3_pred_n", "model_speed_housing_4_pred_n"],
        pos: ["model_speed_housing_5_pred_n", "model_speed_housing_6_pred_n"],
      },
      schema:"acc",
      waves: [2],
    },

    pol_speed_protected: {
      type: "likert",
      label: "Projects near Protected Areas: Speed vs Environment",
      fulltext: "Projects built on or near protected natural areas: When it comes to speeding up construction... indicate whether you think we should prioritize building quickly or protecting the environment - even if it means delays.",
      keys: [
        "model_speed_protected_1_pred_n",
        "model_speed_protected_2_pred_n",
        "model_speed_protected_3_pred_n",
        "model_speed_protected_4_pred_n",
        "model_speed_protected_5_pred_n",
        "model_speed_protected_6_pred_n",
      ],
      labels: {
        "model_speed_protected_1_pred_n": "Strongly prioritize faster building",
        "model_speed_protected_2_pred_n": "Somewhat prioritize faster building",
        "model_speed_protected_3_pred_n": "Balance both equally",
        "model_speed_protected_4_pred_n": "Not sure",
        "model_speed_protected_5_pred_n": "Somewhat prioritize environmental protections",
        "model_speed_protected_6_pred_n": "Strongly prioritize environmental protections",
      },


      colors: {
        "model_speed_protected_1_pred_n": "#b71c1c",
        "model_speed_protected_2_pred_n": "#ef5350",
        "model_speed_protected_3_pred_n": "#bdbdbd",
        "model_speed_protecte_4_pred_n": "#9e9e9e",
        "model_speed_protected_5_pred_n": "#a2dda5",
        "model_speed_protected_6_pred_n": "#2e7d32",
      },
      polarity: {
        neg: ["model_speed_protected_1_pred_n", "model_speed_protected_2_pred_n"],
        neu: ["model_speed_protected_3_pred_n", "model_speed_protected_4_pred_n"],
        pos: ["model_speed_protected_5_pred_n", "model_speed_protected_6_pred_n"],
      },
      schema:"acc",
      waves: [2],
    },

    // --- Speed Roads ---
    // pol_speed_roads: {
    //   type: "likert",
    //   label: "Roads/Highways: Speed vs Environment",
    //   fulltext: "Roads, highways, and bridges: When it comes to speeding up construction... indicate whether you think we should prioritize building quickly or protecting the environment - even if it means delays.",
    //   keys: [
    //     "model_speed_roads_1_pred_n",
    //     "model_speed_roads_2_pred_n",
    //     "model_speed_roads_3_pred_n",
    //     "model_speed_roads_4_pred_n",
    //     "model_speed_roads_5_pred_n",
    //     "model_speed_roads_6_pred_n",
    //   ],
    //   labels: {
    //     "model_speed_roads_1_pred_n": "Strongly prioritize faster building",
    //     "model_speed_roads_2_pred_n": "Somewhat prioritize faster building",
    //     "model_speed_roads_3_pred_n": "Balance both equally",
    //     "model_speed_roads_4_pred_n": "Not sure",
    //     "model_speed_roads_5_pred_n": "Somewhat prioritize environmental protections",
    //     "model_speed_roads_6_pred_n": "Strongly prioritize environmental protections",
    //   },


    //   colors: {
    //     "model_speed_roads_1_pred_n": "#b71c1c",
    //     "model_speed_roads_2_pred_n": "#ef5350",
    //     "model_speed_roads_3_pred_n": "#bdbdbd",
    //     "model_speed_roads_4_pred_n": "#9e9e9e",
    //     "model_speed_roads_5_pred_n": "#a2dda5",
    //     "model_speed_roads_6_pred_n": "#2e7d32",
    //   },
    //   polarity: {
    //     neg: ["model_speed_roads_1_pred_n", "model_speed_roads_2_pred_n"],
    //     neu: ["model_speed_roads_3_pred_n", "model_speed_roads_4_pred_n"],
    //     pos: ["model_speed_roads_5_pred_n", "model_speed_roads_6_pred_n"],
    //   },
    //   schema:"acc",
    //   waves: [2],
    // },



    // // --- Energy: Growing Demand - Efficiency ---
    // pol_energy_demand_efficiency: {
    //   type: "likert",
    //   label: "Meeting Energy Demand: Efficiency",
    //   fulltext: "Encouraging energy efficiency in homes and businesses: You mentioned that you think the U.S.'s energy needs will 'Continue to grow' or 'fluctuate'. How important do you think each of the following is for meeting that growing demand?",
    //   keys: [
    //     "model_energy_grow_demand_efficiency_important_pred_n",
    //     "model_energy_grow_demand_efficiency_neutral_pred_n",
    //     "model_energy_grow_demand_efficiency_notimportant_pred_n",
    //     "model_energy_grow_demand_notGrowing_pred_n_efficiency",
    //   ],
    //   labels: {
    //     "model_energy_grow_demand_efficiency_important_pred_n": "Important",
    //     "model_energy_grow_demand_efficiency_neutral_pred_n": "Neutral",
    //     "model_energy_grow_demand_efficiency_notimportant_pred_n": "Not Important",
    //     "model_energy_grow_demand_notGrowing_pred_n_efficiency": "Do not think it will grow",
    //   },
    //   polarity: {
    //     pos: ["model_energy_grow_demand_efficiency_important_pred_n"],
    //     neu: ["model_energy_grow_demand_efficiency_neutral_pred_n", "model_energy_grow_demand_notGrowing_pred_n_efficiency"],
    //     neg: ["model_energy_grow_demand_efficiency_notimportant_pred_n"],
    //   },
    //   schema: "acc",
    // },

    // // --- Energy: Growing Demand - Infrastructure ---
    // pol_energy_demand_infra: {
    //   type: "likert",
    //   label: "Meeting Energy Demand: Infrastructure",
    //   fulltext: "Improving energy infrastructure (e.g., power grids, pipelines): You mentioned that you think the U.S.'s energy needs will 'Continue to grow' or 'fluctuate'. How important do you think each of the following is for meeting that growing demand?",
    //   keys: [
    //     "model_energy_grow_demand_infra_important_pred_n",
    //     "model_energy_grow_demand_infra_neutral_pred_n",
    //     "model_energy_grow_demand_infra_notimportant_pred_n",
    //     "model_energy_grow_demand_notGrowing_pred_n_infra",
    //   ],
    //   labels: {
    //     "model_energy_grow_demand_infra_important_pred_n": "Important",
    //     "model_energy_grow_demand_infra_neutral_pred_n": "Neutral",
    //     "model_energy_grow_demand_infra_notimportant_pred_n": "Not Important",
    //     "model_energy_grow_demand_notGrowing_pred_n_infra": "Do not think it will grow",
    //   },
    //   polarity: {
    //     pos: ["model_energy_grow_demand_infra_important_pred_n"],
    //     neu: ["model_energy_grow_demand_infra_neutral_pred_n", "model_energy_grow_demand_notGrowing_pred_n_infra"],
    //     neg: ["model_energy_grow_demand_infra_notimportant_pred_n"],
    //   },
    //   schema: "acc",
    // },

    // // --- Energy: Growing Demand - New Technologies ---
    // pol_energy_demand_newtech: {
    //   type: "likert",
    //   label: "Meeting Energy Demand: New Technologies",
    //   fulltext: "Investing in new technologies (e.g., geothermal, advanced nuclear, battery storage): You mentioned that you think the U.S.'s energy needs will 'Continue to grow' or 'fluctuate'. How important do you think each of the following is for meeting that growing demand?",
    //   keys: [
    //     "model_energy_grow_demand_newtech_important_pred_n",
    //     "model_energy_grow_demand_newtech_neutral_pred_n",
    //     "model_energy_grow_demand_newtech_notimportant_pred_n",
    //     "model_energy_grow_demand_notGrowing_pred_n_newtech",
    //   ],
    //   labels: {
    //     "model_energy_grow_demand_newtech_important_pred_n": "Important",
    //     "model_energy_grow_demand_newtech_neutral_pred_n": "Neutral",
    //     "model_energy_grow_demand_newtech_notimportant_pred_n": "Not Important",
    //     "model_energy_grow_demand_notGrowing_pred_n_newtech": "Do not think it will grow",
    //   },
    //   polarity: {
    //     pos: ["model_energy_grow_demand_newtech_important_pred_n"],
    //     neu: ["model_energy_grow_demand_newtech_neutral_pred_n", "model_energy_grow_demand_notGrowing_pred_n_newtech"],
    //     neg: ["model_energy_grow_demand_newtech_notimportant_pred_n"],
    //   },
    //   schema: "acc",
    // },

    // // --- Energy: Growing Demand - Permitting ---
    // pol_energy_demand_permitting: {
    //   type: "likert",
    //   label: "Meeting Energy Demand: Permitting",
    //   fulltext: "Streamlining government permitting for energy projects: You mentioned that you think the U.S.'s energy needs will 'Continue to grow' or 'fluctuate'. How important do you think each of the following is for meeting that growing demand?",
    //   keys: [
    //     "model_energy_grow_demand_permitting_important_pred_n",
    //     "model_energy_grow_demand_permitting_neutral_pred_n",
    //     "model_energy_grow_demand_permitting_notimportant_pred_n",
    //     "model_energy_grow_demand_notGrowing_pred_n_permitting",
    //   ],
    //   labels: {
    //     "model_energy_grow_demand_permitting_important_pred_n": "Important",
    //     "model_energy_grow_demand_permitting_neutral_pred_n": "Neutral",
    //     "model_energy_grow_demand_permitting_notimportant_pred_n": "Not Important",
    //     "model_energy_grow_demand_notGrowing_pred_n_permitting": "Do not think it will grow",
    //   },
    //   polarity: {
    //     pos: ["model_energy_grow_demand_permitting_important_pred_n"],
    //     neu: ["model_energy_grow_demand_permitting_neutral_pred_n", "model_energy_grow_demand_notGrowing_pred_n_permitting"],
    //     neg: ["model_energy_grow_demand_permitting_notimportant_pred_n"],
    //   },
    //   schema: "acc",
    // },

    // // --- Energy: Growing Demand - Renewables ---
    // pol_energy_demand_renewables: {
    //   type: "likert",
    //   label: "Meeting Energy Demand: Renewables",
    //   fulltext: "Investing in renewable energy (e.g., wind, solar, hydrogen): You mentioned that you think the U.S.'s energy needs will 'Continue to grow' or 'fluctuate'. How important do you think each of the following is for meeting that growing demand?",
    //   keys: [
    //     "model_energy_grow_demand_renewables_important_pred_n",
    //     "model_energy_grow_demand_renewables_neutral_pred_n",
    //     "model_energy_grow_demand_renewables_notimportant_pred_n",

    //   ],
    //   labels: {
    //     "model_energy_grow_demand_renewables_important_pred_n": "Important",
    //     "model_energy_grow_demand_renewables_neutral_pred_n": "Neutral",
    //     "model_energy_grow_demand_renewables_notimportant_pred_n": "Not Important",

    //   },
    //   polarity: {
    //     pos: ["model_energy_grow_demand_renewables_important_pred_n"],
    //     neu: ["model_energy_grow_demand_renewables_neutral_pred_n", "model_energy_grow_demand_notGrowing_pred_n_renewables"],
    //     neg: ["model_energy_grow_demand_renewables_notimportant_pred_n"],
    //   },
    //   schema: "acc",
    // },

    // // --- Energy: Growing Demand - Traditional Sources ---
    // pol_energy_demand_trad: {
    //   type: "likert",
    //   label: "Meeting Energy Demand: Traditional Sources",
    //   fulltext: "Expanding traditional energy sources (e.g., oil, gas, nuclear): You mentioned that you think the U.S.'s energy needs will 'Continue to grow' or 'fluctuate'. How important do you think each of the following is for meeting that growing demand?",
    //   keys: [
    //     "model_energy_grow_demand_trad_important_pred_n",
    //     "model_energy_grow_demand_trad_neutral_pred_n",
    //     "model_energy_grow_demand_trad_notimportant_pred_n",
    //     "model_energy_grow_demand_notGrowing_pred_n_trad",
    //   ],
    //   labels: {
    //     "model_energy_grow_demand_trad_important_pred_n": "Important",
    //     "model_energy_grow_demand_trad_neutral_pred_n": "Neutral",
    //     "model_energy_grow_demand_trad_notimportant_pred_n": "Not Important",
    //     "model_energy_grow_demand_notGrowing_pred_n_trad": "Do not think it will grow",
    //   },
    //   polarity: {
    //     pos: ["model_energy_grow_demand_trad_important_pred_n"],
    //     neu: ["model_energy_grow_demand_trad_neutral_pred_n", "model_energy_grow_demand_notGrowing_pred_n_trad"],
    //     neg: ["model_energy_grow_demand_trad_notimportant_pred_n"],
    //   },
    //   schema: "acc",
    // },

    // ─── Data centers & water scarcity (Wave 3 — new) ───────────────────────
    // Q4.1a — support/oppose data centers nationally (3-way collapsed).
    pol_dc_support_usa: {
      type: "likert",
      label: "Support for data centers (nationally)",
      fulltext: "In general, do you support or oppose the construction of data centers in the USA?",
      keys: [
        "model_DC_support_USA_pred_n",
        "model_DC_neither_USA_pred_n",
        "model_DC_oppose_USA_pred_n",
      ],
      labels: {
        "model_DC_support_USA_pred_n": "Support",
        "model_DC_neither_USA_pred_n": "Neither support nor oppose",
        "model_DC_oppose_USA_pred_n": "Oppose",
      },
      colors: {
        "model_DC_support_USA_pred_n": "#2e7d32",
        "model_DC_neither_USA_pred_n": "#9e9e9e",
        "model_DC_oppose_USA_pred_n": "#c62828",
      },
      polarity: {
        pos: "model_DC_support_USA_pred_n",
        neu: "model_DC_neither_USA_pred_n",
        neg: "model_DC_oppose_USA_pred_n",
      },
      schema: "acc",
      waves: [3],
    },

    // Q4.1b — support/oppose data centers in your local area (3-way collapsed).
    pol_dc_support_local: {
      type: "likert",
      label: "Support for data centers (local area)",
      fulltext: "In general, do you support or oppose the construction of data centers in your local area?",
      keys: [
        "model_DC_support_local_pred_n",
        "model_DC_neither_local_pred_n",
        "model_DC_oppose_local_pred_n",
      ],
      labels: {
        "model_DC_support_local_pred_n": "Support",
        "model_DC_neither_local_pred_n": "Neither support nor oppose",
        "model_DC_oppose_local_pred_n": "Oppose",
      },
      colors: {
        "model_DC_support_local_pred_n": "#2e7d32",
        "model_DC_neither_local_pred_n": "#9e9e9e",
        "model_DC_oppose_local_pred_n": "#c62828",
      },
      polarity: {
        pos: "model_DC_support_local_pred_n",
        neu: "model_DC_neither_local_pred_n",
        neg: "model_DC_oppose_local_pred_n",
      },
      schema: "acc",
      waves: [3],
    },

    // Q4.2a — top reasons to SUPPORT data centers (nationally). Checklist.
    pol_dc_support_reasons_usa: {
      type: "categorical",
      label: "Reasons to support data centers (nationally)",
      fulltext: "You said you would support the construction of a data center in the US. Please select the top two reasons for this.",
      keys: [
        "model_USA_DC_support_jobs_pred_n",
        "model_USA_DC_support_econ_growth_pred_n",
        "model_USA_DC_support_local_investment_pred_n",
        "model_USA_DC_support_tax_pred_n",
        "model_USA_DC_support_tech_leadership_pred_n",
        "model_USA_DC_support_natsec_pred_n",
      ],
      labels: {
        "model_USA_DC_support_jobs_pred_n": "Create jobs",
        "model_USA_DC_support_econ_growth_pred_n": "Good for economic growth",
        "model_USA_DC_support_local_investment_pred_n": "Bring investment & infrastructure",
        "model_USA_DC_support_tax_pred_n": "Generate tax revenue",
        "model_USA_DC_support_tech_leadership_pred_n": "Strengthen U.S. tech leadership",
        "model_USA_DC_support_natsec_pred_n": "Protect national security / keep data in U.S. control",
      },
      schema: "acc",
      waves: [3],
    },

    // Q4.2a — top reasons to SUPPORT data centers (local area). Checklist.
    pol_dc_support_reasons_local: {
      type: "categorical",
      label: "Reasons to support data centers (local area)",
      fulltext: "You said you would support the construction of a data center in your local area. Please select the top two reasons for this.",
      keys: [
        "model_local_DC_support_jobs_pred_n",
        "model_local_DC_support_econ_growth_pred_n",
        "model_local_DC_support_local_investment_pred_n",
        "model_local_DC_support_tax_pred_n",
        "model_local_DC_support_tech_leadership_pred_n",
        "model_local_DC_support_natsec_pred_n",
      ],
      labels: {
        "model_local_DC_support_jobs_pred_n": "Create jobs",
        "model_local_DC_support_econ_growth_pred_n": "Good for economic growth",
        "model_local_DC_support_local_investment_pred_n": "Bring investment & infrastructure",
        "model_local_DC_support_tax_pred_n": "Generate tax revenue",
        "model_local_DC_support_tech_leadership_pred_n": "Strengthen U.S. tech leadership",
        "model_local_DC_support_natsec_pred_n": "Protect national security / keep data in U.S. control",
      },
      schema: "acc",
      waves: [3],
    },

    // Q4.2b — top reasons to OPPOSE data centers (nationally). Checklist.
    pol_dc_oppose_reasons_usa: {
      type: "categorical",
      label: "Reasons to oppose data centers (nationally)",
      fulltext: "You said you would oppose the construction of a data center in the US. Please select the top two reasons for this.",
      keys: [
        "model_USA_DC_oppose_envimpact_pred_n",
        "model_USA_DC_oppose_energy_price_pred_n",
        "model_USA_DC_oppose_landuse_pred_n",
        "model_USA_DC_oppose_noise_poll_pred_n",
        "model_USA_DC_oppose_disruption_pred_n",
        "model_USA_DC_oppose_trust_companies_pred_n",
        "model_USA_DC_oppose_AI_expansion_pred_n",
      ],
      labels: {
        "model_USA_DC_oppose_envimpact_pred_n": "Adverse environmental impact (water/land use)",
        "model_USA_DC_oppose_energy_price_pred_n": "Push up energy prices",
        "model_USA_DC_oppose_landuse_pred_n": "Poor use of land",
        "model_USA_DC_oppose_noise_poll_pred_n": "Noise & light pollution",
        "model_USA_DC_oppose_disruption_pred_n": "Construction disruption",
        "model_USA_DC_oppose_trust_companies_pred_n": "Distrust the companies building them",
        "model_USA_DC_oppose_AI_expansion_pred_n": "Enable AI expansion / future job losses",
      },
      schema: "acc",
      waves: [3],
    },

    // Q4.2b — top reasons to OPPOSE data centers (local area). Checklist.
    pol_dc_oppose_reasons_local: {
      type: "categorical",
      label: "Reasons to oppose data centers (local area)",
      fulltext: "You said you would oppose the construction of a data center in your local area. Please select the top two reasons for this.",
      keys: [
        "model_local_DC_oppose_envimpact_pred_n",
        "model_local_DC_oppose_energy_price_pred_n",
        "model_local_DC_oppose_landuse_pred_n",
        "model_local_DC_oppose_noise_poll_pred_n",
        "model_local_DC_oppose_disruption_pred_n",
        "model_local_DC_oppose_trust_companies_pred_n",
        "model_local_DC_oppose_AI_expansion_pred_n",
      ],
      labels: {
        "model_local_DC_oppose_envimpact_pred_n": "Adverse environmental impact (water/land use)",
        "model_local_DC_oppose_energy_price_pred_n": "Push up energy prices",
        "model_local_DC_oppose_landuse_pred_n": "Poor use of land",
        "model_local_DC_oppose_noise_poll_pred_n": "Noise & light pollution",
        "model_local_DC_oppose_disruption_pred_n": "Construction disruption",
        "model_local_DC_oppose_trust_companies_pred_n": "Distrust the companies building them",
        "model_local_DC_oppose_AI_expansion_pred_n": "Enable AI expansion / future job losses",
      },
      schema: "acc",
      waves: [3],
    },

    // Q4.3 — concern about future clean-water availability (3-way collapsed).
    pol_water_scarcity: {
      type: "likert",
      label: "Concern about future clean water availability",
      fulltext: "How concerned are you about the future availability of clean water?",
      keys: [
        "model_water_concerned_pred_n",
        "model_water_neutral_pred_n",
        "model_water_not_concerned_pred_n",
      ],
      labels: {
        "model_water_concerned_pred_n": "Concerned",
        "model_water_neutral_pred_n": "Neutral",
        "model_water_not_concerned_pred_n": "Not concerned",
      },
      colors: {
        // Concern reads as the negative end here, so it takes the likert red and
        // "not concerned" the green — matching baseColorForLikertKey's palette.
        "model_water_concerned_pred_n": "#C62828",
        "model_water_neutral_pred_n": "#9e9e9e",
        "model_water_not_concerned_pred_n": "#2E7D32",
      },
      polarity: {
        pos: "model_water_concerned_pred_n",
        neu: "model_water_neutral_pred_n",
        neg: "model_water_not_concerned_pred_n",
      },
      schema: "acc",
      waves: [3],
    },

  };

  return { groupsById };
}

// ─── ACC Climate ──────────────────────────────────────────────────────────────

export function getACCClimatecolors() {
  const DISTINCT = [
    "#4e79a7", "#f28e2b", "#e15759", "#76b7b2", "#59a14f",
    "#edc948", "#b07aa1", "#ff9da7", "#9c755f", "#bab0ab"
  ];
  return DISTINCT;
}

export function getACCClimateConfig() {
  const groupsById = {


    pol_chinese_dependency: {
      type: "likert",
      label: "Concern regarding US dependency on Chinese technology",
      fulltext: "In your opinion, is the dependency of the United States on Chinese technology, including battery technology and steel production, seen as a concern for both national security and energy security?",
      keys: [
        "model_chinese_dependancy_1_pred_n",
        "model_chinese_dependancy_2_pred_n",
        "model_chinese_dependancy_3_pred_n",
        "model_chinese_dependancy_4_pred_n",
        "model_chinese_dependancy_5_pred_n",
      ],
      labels: {
        "model_chinese_dependancy_1_pred_n": "Yes, I see it as a major issue",
        "model_chinese_dependancy_2_pred_n": "Yes, but it's only a minor issue",
        "model_chinese_dependancy_3_pred_n": "No opinion",
        "model_chinese_dependancy_4_pred_n": "Not sure",
        "model_chinese_dependancy_5_pred_n": "No, it's not an issue",
      },

         colors: {
        "model_chinese_dependancy_1_pred_n": "#b71c1c",
        "model_chinese_dependancy_2_pred_n": "#ef5350",
        "model_chinese_dependancy_3_pred_n": "#bdbdbd",
        "model_chinese_dependancy_4_pred_n": "#9e9e9e",
        "model_chinese_dependancy_5_pred_n": "#2e7d32",
      },
      polarity: {
        neg: ["model_chinese_dependancy_1_pred_n","model_chinese_dependancy_2_pred_n"],
        neu: ["model_chinese_dependancy_3_pred_n", "model_chinese_dependancy_4_pred_n"],
        pos: "model_chinese_dependancy_5_pred_n",
      },
      schema:"acc",
      waves: [2,3]
    },

    pol_clean_energy_jobs: {
      type: "categorical",
      label: "Support for expansion of clean jobs",
      fulltext: "Considering the potential for clean energy policies to create jobs in the geothermal, nuclear, wind and solar energy industries, which of the following statements best reflects your view?",
      keys: [
        "model_clean_energy_jobs_1_pred_n",
        "model_clean_energy_jobs_2_pred_n",
        "model_clean_energy_jobs_3_pred_n",
        "model_clean_energy_jobs_5_pred_n",
        "model_clean_energy_jobs_6_pred_n",
        "model_clean_energy_jobs_4_pred_n",
      ],
      labels: {
        "model_clean_energy_jobs_1_pred_n": "I strongly support clean energy policies, even if minimal job creation",
        "model_clean_energy_jobs_2_pred_n": "I see value in clean energy policies, if result in job creation",
        "model_clean_energy_jobs_3_pred_n": "I have no strong opinion on clean energy policies/ job creation",
        "model_clean_energy_jobs_5_pred_n": "I have concerns about clean energy policies, but aware of job creation potential",
        "model_clean_energy_jobs_6_pred_n": "I do not support clean energy policies even if they create jobs",
        "model_clean_energy_jobs_4_pred_n": "Don't know"
      },
      schema:"acc",
      waves: [2,3]
    },

    pol_clean_energy_expand: {
      type: "likert",
      label: "Support for expansion of clean energy",
      fulltext: "Do you support or oppose the expansion of clean energy such as nuclear, hydro, wind and solar to meet the energy needs of the future?",
      keys: [
        "model_clean_energy_expansion_support_pred_n",
        "model_clean_energy_expansion_nuetral_pred_n",
        "model_clean_energy_expansion_oppose_pred_n",
      ],
      labels: {
        "model_clean_energy_expansion_support_pred_n": "Support",
        "model_clean_energy_expansion_nuetral_pred_n": "Neutral",
        "model_clean_energy_expansion_oppose_pred_n": "Oppose",
      },
      polarity: {
        pos: "model_clean_energy_expansion_support_pred_n",
        neu: "model_clean_energy_expansion_nuetral_pred_n",
        neg: "model_clean_energy_expansion_oppose_pred_n",
      },
      schema:"acc",
      waves: [2,3],
    },

    pol_climate_change_meaning: {
      type: "categorical",
      label: "Perception of 'taking action on climate change'",
      fulltext: "When you hear people talking about taking action on climate change, what do you think they're mainly talking about?",
      keys: [
        "model_climateChange_choice_pred_n",
        "model_climateChange_evs_pred_n",
        "model_climateChange_future_pred_n",
        "model_climateChange_gnd_pred_n",
        "model_climateChange_green_jobs_pred_n",
        "model_climateChange_int_pred_n",
        "model_climateChange_limit_mean_pred_n",
        "model_climateChange_more_trees_pred_n",
        "model_climateChange_oil_gas_pred_n",
        "model_climateChange_quality_pred_n",
        "model_climateChange_recycle_pred_n",
        "model_climateChange_regs_pred_n",
        "model_climateChange_taxes_pred_n",
        "model_climateChange_wind_solar_pred_n",
      ],
      labels: {
        "model_climateChange_choice_pred_n": "Taking away people's freedoms or choices",
        "model_climateChange_evs_pred_n": "Driving electric vehicles",
        "model_climateChange_future_pred_n": "Helping protect future generations",
        "model_climateChange_gnd_pred_n": "Implementing a Green New Deal",
        "model_climateChange_green_jobs_pred_n": "Creating new \u201cgreen jobs\u201d",
        "model_climateChange_int_pred_n": "Supporting international agreements like the Paris Accord",
        "model_climateChange_limit_mean_pred_n": "Limiting meat or cattle farming",
        "model_climateChange_more_trees_pred_n": "Planting more trees and restoring forests",
        "model_climateChange_oil_gas_pred_n": "Reducing the use of coal, oil, or gas",
        "model_climateChange_quality_pred_n": "Improving air and water quality",
        "model_climateChange_recycle_pred_n": "Recycling and reducing waste",
        "model_climateChange_regs_pred_n": "Passing new government regulations",
        "model_climateChange_taxes_pred_n": "Paying higher taxes or energy bills",
        "model_climateChange_wind_solar_pred_n": "Switching to wind or solar energy",
      },
      schema:"acc",
      waves: [2],
    },

    pol_energy_priority: {
      type: "categorical",
      label: "Priorities for environmental policies",
      fulltext: "When thinking about environmental policies, which of the following statements is closest to your opinion on prioritizing energy independence in the United States and reducing reliance on other nations?",
      keys: [
        "model_energy_priority_1_pred_n",
        "model_energy_priority_2_pred_n",
        "model_energy_priority_3_pred_n",
        "model_energy_priority_4_pred_n",
      ],
      labels: {
        "model_energy_priority_1_pred_n": "Energy independence is a key factor ... I want policies that not only benefit the planet with renewable energy but also strengthen the security of the US",
        "model_energy_priority_2_pred_n": "I strongly believe in reducing our dependence on foreign nations for energy. Environmental policies should prioritize domestic production and contribute to our national security",
        "model_energy_priority_3_pred_n": "Prioritize renewable energy policies... before our national security concerns",
        "model_energy_priority_4_pred_n": "Don't know",
      },
      schema: "acc",
      waves: [2,3],
    },

    pol_env_vs_costs: {
      type: "categorical",
      label: "Environment vs. Cost of Living trade-offs",
      fulltext: "When it comes to the environment and the potential costs associated with protecting it and the impact that would have on your cost of living, which of the following statements best reflects your view?",
      keys: [
        "model_env_vs_costs_1_pred_n",
        "model_env_vs_costs_3_pred_n",
        "model_env_vs_costs_4_pred_n",
        "model_env_vs_costs_2_pred_n",
      ],
      labels: {
        "model_env_vs_costs_1_pred_n": "Environmental policies directly impact my wallet/taxes",
        "model_env_vs_costs_3_pred_n": "Willing to support initiatives even if they increase prices",
        "model_env_vs_costs_4_pred_n": "Care about environment but concerned about cost of living/balance",
        "model_env_vs_costs_2_pred_n": "Don't know",
      },
      schema: "acc",
      waves: [2,3],
    },

  };

  return { groupsById };
}

// ─── Default export: array of 3 tab configs ───────────────────────────────────

export default [
  {
    tab: "acc_politics",
    label: "ACC Politics",
    get metrics() { return getACCPoliticsConfig().groupsById; },
  },
  {
    tab: "acc_policy",
    label: "ACC Policy",
    get metrics() { return getACCPolicyConfig().groupsById; },
  },
  {
    tab: "acc_climate",
    label: "ACC Climate",
    get metrics() { return getACCClimateConfig().groupsById; },
  },
];
